export const appStatuses = {
    initiating: 'initiating',
    initiated: 'initiated',
    initiationFailed: 'initiationFailed',
    disconnected: 'disconnected'
};

//Must be a superset of RedGate.SqlClone.Api.Images.ImageState 
export const imageStatuses = {
    failed: 'failed',//Not part of RedGate.SqlClone.Api.Images.ImageState
    requested: 'requested',//Not part of RedGate.SqlClone.Api.Images.ImageState
    beingCreated: 'beingCreated',
    created: 'created',
    missing: 'missing',
    deleted: 'deleted',
    beingDeleted: 'beingDeleted',
    failedToCreate: 'failedToCreate'
};

//Must be a superset of RedGate.SqlClone.Api.Clones.CloneState
export const cloneStatuses = {
    beingCreated: 'beingCreated',
    online: 'online',
    offline: 'offline',
    missing: 'missing',
    deleted: 'deleted',
    beingDeleted: 'beingDeleted',
    failedToCreate: 'failedToCreate'
};

//Must be a superset of RedGate.SqlClone.Api.Operations.OperationState
export const operationStatuses = {
    userRequested: 'userRequested',
    dispatchedToAgent: 'dispatchedToAgent',
    started: 'started',
    successful: 'successful',
    faulted: 'faulted'
};

export const operationIsComplete = operationStatus => {
    return operationStatus === operationStatuses.successful || operationStatus === operationStatuses.faulted;
};

export const agentStatuses = {
    disconnected: 'disconnected',
    connected: 'connected'
};

export const asyncronousOperationStatuses = {
    initial: 'initial',
    requested: 'requested',
    requestAccepted: 'requestAccepted',
    requestRejected: 'requestRejected',
    success: 'success',
    failure: 'failure'
};

export const updateStatuses = {
    initial: 'initial',
    requested: 'requested',
    success: 'success',
    failure: 'failure'
};

export const messageSeverities = {
    info: 'info',
    warning: 'warning',
    error: 'error'
};

export const licenceStatuses = {
    none: 'none',
    expired: 'expired',
    trial: 'trial',
    licensed: 'licensed'
};

export const imageCreationStatuses = updateStatuses;
export const cloneCreationStatuses = updateStatuses;


// WEBPACK FOOTER //
// ./src/js/statuses.js